import { useEffect } from 'react'
import { connect } from 'react-redux'
import { initYoutubeAPI } from '../../store/youtubeReady'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import get from 'lodash/get'
import YoutubeQuestioner from './YoutubeQuestioner'

function YoutubeInitializer({ initYoutubeAPI, youtubeReady, youtubeId, questions }) {
  useEffect(() => {
    if (!youtubeReady) {
      window.onYouTubeIframeAPIReady = initYoutubeAPI
    }
  }, [initYoutubeAPI, youtubeReady])

  return youtubeReady ? (
    <YoutubeQuestioner youtubeId={youtubeId} questions={questions} />
  ) : (
    <HelmetProvider>
      <Helmet>
        <script src="https://www.youtube.com/iframe_api"></script>
      </Helmet>
    </HelmetProvider>
  )
}

const mapState = state => ({ youtubeReady: get(state, 'youtubeReady') })

const mapDispatch = dispatch => ({
  initYoutubeAPI: () => dispatch(initYoutubeAPI())
})

export default connect(mapState, mapDispatch)(YoutubeInitializer)
